<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";
import CardBoxComponentRestricted from '@/Components/CardBoxComponentRestricted.vue';

defineProps({
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    courseareas: Array,
    //select_level: Array
});
const rutaprefijo = ref('coursearea');
const modulo = ref('Área curricular');
</script>

<template>

    <Head title="Áreas curriculares" />

    <BreezeAuthenticatedLayout>

        <template #header>
        <PremiumPageHeader :icon="mdiCog" title="Áreas curriculares" subtitle="Gestión de áreas curriculares">
        </PremiumPageHeader>
    </template>


        <div>
            <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">

                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                <CardBox v-if="canRead" has-table>
                    <!-- Tablesingle opciones: checkable isRef ya está por defecto en modulo Nivel -->
                    <TableSingle :modulo="modulo" :data="courseareas" isRef :ruta="rutaprefijo" />
                </CardBox>
                <CardBox v-else>
                    <CardBoxComponentRestricted />
                </CardBox>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
